import { render, staticRenderFns } from "./Bulletpoints.vue?vue&type=template&id=0b7d0d32&scoped=true&"
import script from "./Bulletpoints.vue?vue&type=script&lang=ts&"
export * from "./Bulletpoints.vue?vue&type=script&lang=ts&"
import style0 from "./Bulletpoints.vue?vue&type=style&index=0&id=0b7d0d32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7d0d32",
  null
  
)

export default component.exports